/* global Materialize */
import $ from 'jquery'

/* @ngInject */
const myDate = (
  labels,
  $timeout,
  utils,
  $$setting,
  optionsHandler,
  types
) => {
  return {
    restrict: 'E',
    scope: {
      ngModel: '=',
      myOptions: '=',
      myStyle: '=?',
      myDisabled: '=?',
      myMaterialDate: '=?',
      enableValidator: '=?',
    },
    template: require('./myDate.html'),

    /* @ngInject */
    controller: ($scope, $filter) => {
      $timeout(() => {
        $('.datepicker').pickadate({
          selectMonths: true,
          selectYears: 50,
          format: 'dd/mm/yyyy',
        })
        Materialize.updateTextFields()
      })

      $scope.$$setting = $$setting

      $scope.forceDatePicker = () => {
        $timeout(() => {
          document.querySelector(`.${$scope.id}`).focus()
        })
      }
    },
    link: {
      pre: (scope, element, attrs) => {

        if ($$setting.data.general.checkboxs.calendar.model) {
          element.find('input').attr('class', 'datepicker')
        } else {
          element.find('input').attr('date', '')
        }

        const defaultOptions = {
          icon: '',
          label: '',
          ref: '',
          required: false,
          disabled: false,
          type: types.date,
          displayNullRadio: false,
          unique: false,
          messages: {
            exists: labels.error.input.exists,
          },
        }

        const options = optionsHandler.setDefaults(scope.myOptions, defaultOptions)

        scope.icon = options.icon
        scope.label = options.label
        scope.id = `${options.ref}-${(Math.random() + '').replace('.', '')}`
        scope.required = false
        scope.disabled = options.disabled
        scope.type = options.type
        scope.displayNullRadio = options.displayNullRadio
        scope.messages = options.messages

        if (scope.enableValidator) {
          scope.required = options.required
          scope.displayNullRadio = !options.required
          if (options.unique) {
            scope.validator = {
              nature: scope.myNature,
              field: scope.myName,
            }
          }
        }
      },
      post: (scope, element, attrs) => {

      },
    },
  }
}

export default myDate



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/myDate.js